import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import {
  Container, Typography, Button, Box, Paper,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, Alert
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const API = process.env.REACT_APP_API_URL;

export default function Clientes() {
  const { usuario } = useAuth();
  const [clientes, setClientes] = useState([]);
  const [open, setOpen] = useState(false);
  const [editando, setEditando] = useState(null);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    nombre: '',
    contacto: '',
    email: ''
  });

  const cargarClientes = () => {
    axios.get(`${API}/api/clientes`, { params: { empresa_id: usuario?.empresa_id } })
      .then(r => setClientes(Array.isArray(r.data) ? r.data : []))
      .catch(() => setClientes([]));
  };

  useEffect(() => { cargarClientes(); }, []);

  const abrirCrear = () => {
    setEditando(null);
    setForm({ nombre: '', contacto: '', email: '' });
    setError('');
    setOpen(true);
  };

  const abrirEditar = (cliente) => {
    setEditando(cliente);
    setForm({ nombre: cliente.nombre, contacto: cliente.contacto || '', email: cliente.email || '' });
    setError('');
    setOpen(true);
  };

  const guardar = async () => {
    try {
      const clienteData = { ...form, empresa_id: usuario?.empresa_id || null };
      if (editando) {
        await axios.put(`${API}/api/clientes/${editando.id}`, clienteData);
      } else {
        await axios.post(`${API}/api/clientes`, clienteData);
      }
      setOpen(false);
      setError('');
      cargarClientes();
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al guardar cliente');
    }
  };

  const eliminar = async (id) => {
    if (window.confirm('¿Eliminar este cliente?')) {
      await axios.delete(`${API}/api/clientes/${id}`);
      cargarClientes();
    }
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">Clientes</Typography>
        {usuario?.rol === 'admin' || usuario?.rol === 'super_admin' ? (
          <Button variant="contained" startIcon={<AddIcon />} onClick={abrirCrear}>
            Nuevo Cliente
          </Button>
        ) : null}
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Nombre</b></TableCell>
              <TableCell><b>Contacto</b></TableCell>
              <TableCell><b>Email</b></TableCell>
              <TableCell><b>Acciones</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {clientes.map(c => (
              <TableRow key={c.id}>
                <TableCell>{c.nombre}</TableCell>
                <TableCell>{c.contacto || '—'}</TableCell>
                <TableCell>{c.email || '—'}</TableCell>
                <TableCell>
                  {(usuario?.rol === 'admin' || usuario?.rol === 'super_admin') && (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Button
                        size="small"
                        startIcon={<EditIcon />}
                        onClick={() => abrirEditar(c)}
                      >
                        Editar
                      </Button>
                      <Button
                        size="small"
                        color="error"
                        startIcon={<DeleteIcon />}
                        onClick={() => eliminar(c.id)}
                      >
                        Eliminar
                      </Button>
                    </Box>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {clientes.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No hay clientes aún
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>{editando ? 'Editar Cliente' : 'Nuevo Cliente'}</DialogTitle>
        <DialogContent>
          {error && <Alert severity="error" sx={{ mb: 2, mt: 1 }}>{error}</Alert>}
          <TextField
            fullWidth label="Nombre" value={form.nombre}
            onChange={e => setForm({ ...form, nombre: e.target.value })}
            sx={{ mb: 2, mt: 1 }}
          />
          <TextField
            fullWidth label="Contacto" value={form.contacto}
            onChange={e => setForm({ ...form, contacto: e.target.value })}
            sx={{ mb: 2 }}
          />
          <TextField
            fullWidth label="Email" type="email" value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancelar</Button>
          <Button variant="contained" onClick={guardar}>
            {editando ? 'Guardar' : 'Crear'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}